import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { BulkEntryGrid } from '../components/BulkEntryGrid';
import { useCompany } from '../contexts/CompanyContext';
import api from '../lib/api';
import { toast } from 'sonner';
import { ArrowLeft, Layers } from 'lucide-react';

const UNIT_OPTIONS = [
  { value: 'Meters', label: 'Meters' },
  { value: 'Bales', label: 'Bales' },
  { value: 'Thans', label: 'Thans' },
  { value: 'Kg', label: 'Kg' },
  { value: 'Pieces', label: 'Pieces' },
];

const BulkQualities = () => {
  const navigate = useNavigate();
  const { activeCompany } = useCompany();
  const [sharedDefaults, setSharedDefaults] = useState({ default_unit: 'Meters' });

  const columns = useMemo(() => [
    { key: 'quality_name', label: 'Quality Name', required: true, placeholder: 'e.g. Cotton 40s', width: '220px' },
    { key: 'default_unit', label: 'Unit', required: true, type: 'select', width: '130px',
      options: UNIT_OPTIONS, defaultValue: 'Meters', sharedDefault: true,
      onSharedChange: (d) => setSharedDefaults(prev => ({ ...prev, default_unit: d.default_unit }))
    },
    { key: 'description', label: 'Description', placeholder: 'Optional notes', width: '280px' },
  ], []);

  const handleSave = async (rows) => {
    const processed = rows.map(r => ({ ...r, unit_type: r.default_unit }));
    const res = await api.post('/bulk/qualities', { rows: processed });
    if (res.data.success_count > 0) {
      toast.success(`${res.data.success_count} quality/qualities created successfully`);
    }
    if (res.data.error_count > 0) {
      toast.error(`${res.data.error_count} row(s) had errors`);
    }
    return res.data;
  };

  return (
    <div className="space-y-6" data-testid="bulk-qualities-page">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="bulk-qualities-back">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>Bulk Add Qualities</h1>
            <p className="text-sm text-slate-500 mt-0.5">
              Add multiple qualities at once · <span className="theme-text font-medium">{activeCompany?.name}</span>
            </p>
          </div>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate('/masters')} className="gap-1.5">
          <Layers className="h-4 w-4" /> View Masters
        </Button>
      </div>

      <Card>
        <CardContent className="p-6">
          <BulkEntryGrid
            columns={columns}
            sharedDefaults={sharedDefaults}
            onSave={handleSave}
            entityName="Quality"
            testIdPrefix="bulk-ql"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default BulkQualities;
